export const DEFAULT_TOOLTIP_DATA = {
  content: '',
  center: [0, 0],
  hidden: true,
  hover: null,
};
